import "react-native-get-random-values";
import "react-native-gesture-handler";
import "@expo/metro-runtime";
import React, { Suspense, useEffect } from "react";
import Constants from "expo-constants";
import * as SplashScreen from "expo-splash-screen";
import { filterErrors } from "@utils/errors-logger";
import "./src/global.css";
import { Platform, I18nManager } from "react-native";
import ErrorBoundary from "./src/components/common/ErrorBoundary";
import { isSharedCollectionEntry } from "@utils/sharedCollectionEntry";
// EAS Observe: ObserveRoot wraps the root component to automatically measure
// Time to First Render (TTR). This is the earliest instrumentation point.
import { Observe } from "expo-observe";
import { Provider } from "react-redux";
import { store } from "@redux/store";

// EAS Observe: Enable React Navigation integration for per-screen metrics.
// Must be called before any components render.

const enableObserve = process.env.EXPO_PUBLIC_ENABLE_OBSERVE === "true";

if (enableObserve) {
  Observe.configure({
    integrations: {
      "react-navigation": true,
    },
  });
}

const MainApp =
  Platform.OS === "web"
    ? React.lazy(() => import("./src/MainApp"))
    : require("./src/MainApp").default;

const SharedCollectionRoot =
  Platform.OS === "web"
    ? React.lazy(() => import("@navigations/shared-collection-root"))
    : null;

filterErrors();

I18nManager.allowRTL(false);
I18nManager.forceRTL(false);

SplashScreen.preventAutoHideAsync();

function App() {
  useEffect(() => {
    if (Platform.OS === "web") {
      const viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      viewportMeta.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      document.head.appendChild(viewportMeta);
    }
  }, []);

  if (SharedCollectionRoot && isSharedCollectionEntry()) {
    return (
      <ErrorBoundary>
        <Suspense fallback={null}>
          <Provider store={store}>
            <SharedCollectionRoot />
          </Provider>
        </Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <MainApp />
      </Suspense>
    </ErrorBoundary>
  );
}

let AppEntryPoint = App;

if (__DEV__ && Constants?.expoConfig?.extra?.storybookEnabled === "true") {
  try {
    AppEntryPoint = require("./.ondevice").default;
  } catch {
    // Storybook not available in this bundle; fall back to the app entry point.
  }
}

export default AppEntryPoint;
